
import { IEntity, IEntityImporter } from '@/typings/import';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Passenger from '@/components/Passenger/models/Passenger';
import PassengerImportsTable from '@/components/Importer/passenger/PassengerImportsTable.vue';
import TransportationPermission from '../Passenger/models/TransportationPermission';
import { IMappers } from './ImportSelectionStep.vue';
import PropertyUpdateTable from '@/components/Importer/PropertyUpdateTable.vue';
import TransportationPermissionImportsTable from '@/components/Importer/transportationPermission/TransportationPermissionImportsTable.vue';

interface ITab {
  value: number;
  title: string;
  component: any;
  props: any;
}

export interface IImportsTableHeader {
  name: string;
  value: string;
}

@Component({
  components: {
    PassengerImportsTable,
    PropertyUpdateTable,
    TransportationPermissionImportsTable,
  },
})
export default class ImportsTable extends Vue {
  tabIndex: number = 0;
  
  showSelectedRow: boolean = false;
  selectedRow: IEntity<any> | null = null;

  @Prop({ required: true }) mappings: IMappers;
  @Prop({ required: true }) passengerImporter: IEntityImporter<Passenger>;
  @Prop({ default: () => [] }) ptpImporters: Array<IEntityImporter<TransportationPermission>>;

  get tabs(): ITab[] {
    /*tslint:disable-next-line */
    let tabs: ITab[] = [
      { 
        value: 0, 
        title: this.$t('generic.header.passenger.many'), 
        component: PassengerImportsTable, 
        props: { passengerImporter: this.passengerImporter, } 
      },
    ];

    if (this.ptpImporters.length > 0) {
      let valueMax = tabs.length;
      const ptpTabs = this.ptpImporters.map((importer, i) => {
        const value = valueMax++;
        const ptpTab = { 
          value, 
          title: this.$t('generic.transportationPermission') + ` ${i + 1}`,
          component: TransportationPermissionImportsTable, 
          props: { ptpImporter: importer, } 
        };
        return ptpTab;
      });

      tabs = tabs.concat(ptpTabs);
    }
    return tabs;
  }

  selectRow(row: IEntity<Passenger>) {
    this.selectedRow = row;
    this.showSelectedRow = true;
  }

  closeRowDialog() {
    this.showSelectedRow = false;
    this.selectedRow = null;
  }

}
